// import { useState } from "react";
// import { decryptData } from "../utils";
// import { useDispatch } from "react-redux";
// import { getBookingSignedUrl } from "../redux/actions/todoPerformance";
// import { Dialog, Transition } from "@headlessui/react";
// import { Fragment } from "react";

// const FileViewer = ({ file_upload_id, file_name = "" }) => {
//   const dispatch = useDispatch();
//   const [isOpen, setIsOpen] = useState(false);
//   const [fileUrl, setFileUrl] = useState("");
//   const [type, setType] = useState("");

//   const getFileType = (url) => {
//     const fileExtension = url.split(".").pop().split("?")[0].toLowerCase();
//     if (fileExtension.match(/(jpg|jpeg|png|gif)$/)) return "image";
//     if (fileExtension.match(/(pdf)$/)) return "pdf";
//     if (fileExtension.match(/(doc|docx|xls|xlsx)$/)) return "office";
//     return "download";
//   };

//   const handleViewOption = () => {
//     const request = {
//       document_id: file_upload_id,
//       onSuccess: (data) => {
//         const url = decryptData(data);
//         if (url) {
//           const fileType = getFileType(url);
//           setType(fileType);
//           setFileUrl(url);
//           setIsOpen(true);
//         }
//       },
//       onError: (error) => {
//         console.log("error occur in downloading ---", error);
//       },
//     };
//     dispatch(getBookingSignedUrl(request));
//   };

//   return (
//     <div className="flex justify-center items-center p-4">
//       <button
//         onClick={() => handleViewOption()}
//         className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-700"
//       >
//         View File
//       </button>

//       <Transition appear show={isOpen} as={Fragment}>
//         <Dialog
//           as="div"
//           className="relative z-50"
//           onClose={() => setIsOpen(false)}
//         >
//           <Transition.Child
//             as={Fragment}
//             enter="ease-out duration-300"
//             enterFrom="opacity-0"
//             enterTo="opacity-100"
//             leave="ease-in duration-200"
//             leaveFrom="opacity-100"
//             leaveTo="opacity-0"
//           >
//             <div className="fixed inset-0 bg-black bg-opacity-50" />
//           </Transition.Child>

//           <div className="fixed inset-0 flex items-center justify-center p-4">
//             <Transition.Child
//               as={Fragment}
//               enter="ease-out duration-300"
//               enterFrom="opacity-0 scale-95"
//               enterTo="opacity-100 scale-100"
//               leave="ease-in duration-200"
//               leaveFrom="opacity-100 scale-100"
//               leaveTo="opacity-0 scale-95"
//             >
//               <Dialog.Panel className="bg-white rounded-lg shadow-xl p-6 max-w-4xl w-full">
//                 <Dialog.Title className="text-lg font-semibold text-gray-800">
//                   File Preview
//                 </Dialog.Title>

//                 <div className="mt-4 w-full max-h-[500px] overflow-auto border rounded-lg shadow-md">
//                   {type === "image" && (
//                     <img
//                       src={fileUrl}
//                       alt="Preview"
//                       className="w-full h-auto"
//                     />
//                   )}
//                   {type === "pdf" && (
//                     <iframe
//                       title="File Preview"
//                       src={fileUrl}
//                       className="w-full h-[500px]"
//                     />
//                   )}
//                   {type === "office" && (
//                     <iframe
//                       title="File Preview"
//                       src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
//                         fileUrl
//                       )}`}
//                       className="w-full h-[500px]"
//                     />
//                   )}
//                   {type === "download" && (
//                     <div className="flex flex-col items-center justify-center p-4">
//                       <p className="text-gray-600">
//                         Preview not available. Download the file instead.
//                       </p>
//                       <a
//                         href={fileUrl}
//                         download
//                         className="mt-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-green-600"
//                       >
//                         Download File
//                       </a>
//                     </div>
//                   )}
//                 </div>

//                 <button
//                   onClick={() => setIsOpen(false)}
//                   className="mt-4 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600"
//                 >
//                   Close
//                 </button>
//               </Dialog.Panel>
//             </Transition.Child>
//           </div>
//         </Dialog>
//       </Transition>
//     </div>
//   );
// };

// export default FileViewer;

import { decryptData } from "../utils";
import { useDispatch } from "react-redux";
import { getBookingSignedUrl } from "../redux/actions/todoPerformance";

const BookingFileViewer = ({ file_upload_id, file_name = "", _handleDelete }) => {
  const dispatch = useDispatch();

  const getFileType = (url) => {
    if (url.match(/\.(jpg|jpeg|png|gif)$/)) return "image";
    if (url.match(/\.(pdf)$/)) return "pdf";
    if (url.match(/\.(doc|docx|xls|xlsx)$/)) return "office";
    return "download";
  };

  const handleViewOption = () => {
    const request = {
      document_id: file_upload_id,
      onSuccess: (data) => {
        const url = decryptData(data);
        if (url) {
          openInNewTab(url);
        }
      },
      onError: (error) => {
        console.log("error occur in downloading ---", error);
      },
    };
    dispatch(getBookingSignedUrl(request));
  };

  const openInNewTab = (fileUrl) => {
    const type = getFileType(fileUrl);
    if (type === "office") {
      window.open(
        `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          fileUrl
        )}`,
        "_blank"
      );
    } else {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="flex flex-row justify-between items-center py-1">
      <div className="w-[80%] truncate font-inter font-bold text-[13px] text-[#535860]">
        {file_name}
      </div>
      <div className="flex flex-row items-center space-x-3">
        <div
          title="Download"
          className={`fa-solid fa-arrow-down-to-line text-lg text-[--bg-color-500] cursor-pointer`}
          onClick={(e) => {
            e.stopPropagation();
            handleViewOption();
          }}
        >
        </div>
        <div
          title="Delete"
          className={`fa-regular fa-trash-can text-lg text-rose-500 cursor-pointer`}
          onClick={(e) => {
            e.stopPropagation();
            _handleDelete({booking_file_upload_id: file_upload_id});
          }}
        >
        </div>
      </div>
    </div>
  );
};

export default BookingFileViewer;
